/**
 * Request payload for fetching provenance data
 */
export interface ProvenanceRequest {
    record_id: string;
    storage_location: string;
}

/**
 * Single provenance document response
 */
export interface ProvenanceDocument {
    source_doc: string;
    start: number;
    end: number;
    ner_chunk: string;
    document_type: string;
    filename: string;
    note_ingestion_datetime: number | string; // Can be number (timestamp) or string (timestamp or ISO date)
    note_date?: string | number; // Optional: actual note date (preferred over note_ingestion_datetime)
    confidence: number;
    file_source_path: string;
    source: string;
    title: string;
    file_type: string;
}

/**
 * Data needed to open provenance modal
 */
export interface ProvenanceModalData {
    recordId: number;
    domainId: string;
    storageLocation: string;
    recordName: string;
    recordDate?: string; // Optional: actual record date (e.g., medication start date, procedure date) - preferred over document ingestion date
}
